import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MarkersService {

  private markers: {id:number,name:string,url:string}[] = [
        { id: 30, name: "Circle", url: "assets/markers/poi/tp-circle-bleu.png" },
        { id: 31, name: "Circle", url: "assets/markers/poi/tp-circle-yellow.png" },
        { id: 32, name: "Circle", url: "assets/markers/poi/tp-circle-red.png" },
        { id: 33, name: "Circle", url: "assets/markers/poi/tp-circle-green.png" },
        { id: 34, name: "Circle", url: "assets/markers/poi/tp-circle-orange.png" },

        { id: 35, name: "Triangle ", url: "assets/markers/poi/tp-triangle-bleu.png" },
        { id: 36, name: "Triangle ", url: "assets/markers/poi/tp-triangle-yellow.png" },
        { id: 37, name: "Triangle ", url: "assets/markers/poi/tp-triangle-red.png" },
        { id: 38, name: "Triangle ", url: "assets/markers/poi/tp-triangle-green.png" },
        { id: 39, name: "Triangle ", url: "assets/markers/poi/tp-triangle-orange.png" },

        { id: 40, name: "Star ", url: "assets/markers/poi/tp-star-bleu.png" },
        { id: 41, name: "Star ", url: "assets/markers/poi/tp-star-yellow.png" },
        { id: 42, name: "Star ", url: "assets/markers/poi/tp-star-red.png" },
        { id: 43, name: "Star ", url: "assets/markers/poi/tp-star-green.png" },
        { id: 44, name: "Star ", url: "assets/markers/poi/tp-star-orange.png" },

        { id: 45, name: "Square ", url: "assets/markers/poi/tp-square-bleu.png" },
        { id: 46, name: "Square ", url: "assets/markers/poi/tp-square-yellow.png" },
        { id: 47, name: "Square ", url: "assets/markers/poi/tp-square-red.png" },
        { id: 48, name: "Square ", url: "assets/markers/poi/tp-square-green.png" },
        { id: 49, name: "Square ", url: "assets/markers/poi/tp-square-orange.png" }

    ];

    constructor() {
    }

    getMarkers(): {id:number,name:string,url:string}[] {
        return this.markers;
    }
}
